(() => {
  window.addEventListener("abra:announced", () => {
    const productSelectorNav = document.querySelector(
      ".omb-product-connector__nav"
    );

    if (productSelectorNav) {
      productSelectorNav.addEventListener("click", () => {
        window.dispatchEvent(new CustomEvent("abra:render"));
      });
    }
  });
})();
